import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { IUiTDatabaseOrganizer } from '@internal-models/uit-database.model';
import { UiTDatabaseProvider } from '@internal-providers/uit-database.provider';
@Component({
	selector: 'search-organizer',
	templateUrl: 'search-organizer.component.html',
	styleUrls: ['./search-organizer.component.scss'],
})
export class SearchOrganizerComponent implements OnInit {
	@Input() public label: string;
	@Input() public type: 'autocomplete' | 'search' = 'autocomplete';
	@Output() public readonly selected: EventEmitter<IUiTDatabaseOrganizer> = new EventEmitter();
	@Output() public readonly hasSearchedChanged: EventEmitter<boolean> = new EventEmitter();
	public controlName: string;
	public value: IUiTDatabaseOrganizer;
	public searchString: string;
	public searchResults: Array<IUiTDatabaseOrganizer> = new Array();
	public hasSearched: boolean = false;
	public inputId: number;
	public loading: boolean = false;
	public error: boolean = false;

	constructor(private readonly provider: UiTDatabaseProvider) {
		this.addEventListeners();
	}

	public inputChanged(value: IUiTDatabaseOrganizer): void {
		this.value = value;
	}

	public ngOnInit(): void {
		this.inputId = Math.random();
	}

	public autocomplete(searchString: string): void {
		if (searchString.length > 2) {
			this.loading = true;
			this.provider
				.searchOrganizerByName(searchString)
				.then((data) => {
					this.loading = false;
					this.searchResults = data;
				})
				.catch(() => {
					this.loading = false;
					this.error = true;
				});
		} else this.resetSearch();
	}

	public search(searchString: string = this.searchString): void {
		this.resetSearch();
		this.loading = true;
		this.hasSearched = true;
		this.hasSearchedChanged.emit(this.hasSearched);
		this.provider
			.searchOrganizerByName(searchString)
			.then((data) => {
				this.loading = false;
				this.searchResults = data;
			})
			.catch(() => {
				this.loading = false;
				this.error = true;
			});
	}

	public async selectOrganizer(organizer: IUiTDatabaseOrganizer): Promise<void> {
		this.resetSearch();
		(document.getElementById(`organizer-input-${this.inputId}`) as HTMLInputElement).value = '';
		this.selected.emit(organizer);
	}

	public resetSearch(): void {
		this.searchResults = new Array();
		this.hasSearched = false;
	}

	public addEventListeners(): void {
		document.addEventListener('keydown', (event: KeyboardEvent) => {
			if (
				event.key === 'Escape' ||
				event.key === 'Esc' ||
				event.keyCode === 27 ||
				event.key === 'Tab' ||
				event.keyCode === 9
			) {
				if (this.type === 'autocomplete') {
					this.resetSearch();
				}
			} else if (event.key === 'Enter' || event.code === 'Enter' || event.keyCode === 13) {
				this.search();
			}
		});
		document.addEventListener('click', (event) => {
			if ((event.target as HTMLElement).className !== '_search-result') {
				if (this.type === 'autocomplete') {
					this.resetSearch();
				}
			}
		});
	}
}
